import { AvailabilityColumns } from '@miq/catalog';

export default {
  [AvailabilityColumns.SpaceDetails_AlternateAddress]: {
    field: 'alternate_address.full_street_name',
  },
};
